import { useState } from 'react';
import axios from 'axios';

const AddWidget = () => {
    const [formData, setFormData] = useState({
        id: '',
        widgetName: '',
        description: '',
        widgetSize: '',
        widgetPosition: '',
        status: '',
        widgetPreviewImage: null,
    });

    const handleChange = e => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleFileChange = e => {
        setFormData({
            ...formData,
            widgetPreviewImage: e.target.files[0],
        });
    };

    const handleSubmit = async e => {
        e.preventDefault();
        const formDataToSend = new FormData();
        for (const key in formData) {
            formDataToSend.append(key, formData[key]);
        }

        try {
            const response = await axios.post('/add_widget', formDataToSend, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            console.log(response.data);
            // Handle success (e.g., show a success message)
        } catch (error) {
            console.error('Error adding task:', error);
            // Handle error (e.g., show an error message)
        }
    };

    return (
        <form onSubmit={handleSubmit} className="max-w-lg mx-auto p-4 bg-white shadow-md rounded">
            <div className="mb-4">
                <label className="block text-gray-700">ID:</label>
                <input
                    type="text"
                    name="id"
                    value={formData.id}
                    onChange={handleChange}
                    required
                    className="mt-1 block w-full border border-gray-300 rounded p-2"
                />
            </div>
            <div className="mb-4">
                <label className="block text-gray-700">Widget Name:</label>
                <input
                    type="text"
                    name="widgetName"
                    value={formData.widgetName}
                    onChange={handleChange}
                    required
                    className="mt-1 block w-full border border-gray-300 rounded p-2"
                />
            </div>
            <div className="mb-4">
                <label className="block text-gray-700">Description:</label>
                <textarea
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    required
                    className="mt-1 block w-full border border-gray-300 rounded p-2"
                />
            </div>
            <div className="mb-4">
                <label className="block text-gray-700">Widget Size:</label>
                <input
                    type="text"
                    name="widgetSize"
                    value={formData.widgetSize}
                    onChange={handleChange}
                    required
                    className="mt-1 block w-full border border-gray-300 rounded p-2"
                />
            </div>
            <div className="mb-4">
                <label className="block text-gray-700">Widget Position:</label>
                <input
                    type="text"
                    name="widgetPosition"
                    value={formData.widgetPosition}
                    onChange={handleChange}
                    required
                    className="mt-1 block w-full border border-gray-300 rounded p-2"
                />
            </div>
            <div className="mb-4">
                <label className="block text-gray-700">Status:</label>
                <input
                    type="text"
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                    required
                    className="mt-1 block w-full border border-gray-300 rounded p-2"
                />
            </div>
            <div className="mb-4">
                <label className="block text-gray-700">Widget Preview Image:</label>
                <input
                    type="file"
                    name="widgetPreviewImage"
                    onChange={handleFileChange}
                    required
                    className="mt-1 block w-full border border-gray-300 rounded p-2"
                />
            </div>
            <button
                type="submit"
                className="w-full bg-blue-500 text-white rounded p-2 hover:bg-blue-600"
            >
                Add Task
            </button>
        </form>
    );
};

export default AddWidget;
